import { useEffect, useState } from "react";
import Header from "@/components/enea/Header";
import Hero from "@/components/enea/Hero";
import MCMSection from "@/components/enea/MCMSection";
import MarketDashboard from "@/components/enea/MarketDashboard";
import LogicaCertezza from "@/components/enea/LogicaCertezza";
import WhitePaperSection from "@/components/enea/WhitePaperSection";
import ChatbotSection from "@/components/enea/ChatbotSection";
import PremiumSection from "@/components/enea/PremiumSection";
import ReviewsSection from "@/components/enea/ReviewsSection";
import { CTABanner, MobileStickyCTA } from "@/components/enea/CTABanner";
import VideoGuide from "@/components/enea/VideoGuide";
import Footer from "@/components/enea/Footer";

export default function Landing() {
  const [bootStamp, setBootStamp] = useState("");

  useEffect(() => {
    const now = new Date();
    const iso = now.toISOString().replace("T", " ").slice(0, 19);
    setBootStamp(iso + " UTC");
  }, []);

  return (
    <main className="min-h-screen bg-white text-slate-900" data-testid="landing-root">
      <Header />
      <Hero bootStamp={bootStamp} />
      <MCMSection />
      <CTABanner />
      <MarketDashboard />
      <LogicaCertezza />
      <WhitePaperSection />
      <ChatbotSection />
      <section className="bg-slate-50 py-14 border-y border-slate-200" data-testid="home-video-section">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <div className="text-[11px] font-bold uppercase tracking-[0.24em] text-[#14B8A6]">Come funziona</div>
          <h2 className="mt-2 text-base md:text-lg font-semibold text-[#0b2545]">1 minuto per capire come ottenere la tua valutazione gratuita</h2>
          <div className="mt-5">
            <VideoGuide page="home" />
          </div>
        </div>
      </section>
      <PremiumSection />
      <ReviewsSection />
      <Footer />
      <MobileStickyCTA />
    </main>
  );
}
